var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.847222,
    y: 0.347222,
    width: 24.3056,
    height: 24.3056,
    rx: 4.65278,
    fill: "#0E151D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3492 6.97565C15.5119 7.13844 15.6034 7.35919 15.6034 7.58937C15.6034 7.81954 15.5119 8.0403 15.3492 8.20308L11.0523 12.5L15.3492 16.7968C15.5073 16.9605 15.5948 17.1798 15.5928 17.4074C15.5909 17.635 15.4996 17.8527 15.3386 18.0137C15.1777 18.1746 14.96 18.2659 14.7324 18.2679C14.5048 18.2699 14.2855 18.1824 14.1218 18.0243L9.21119 13.1137C9.04845 12.9509 8.95703 12.7301 8.95703 12.5C8.95703 12.2698 9.04845 12.049 9.21119 11.8862L14.1218 6.97565C14.2846 6.81292 14.5053 6.7215 14.7355 6.7215C14.9657 6.7215 15.1864 6.81292 15.3492 6.97565Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.847222,
    y: 0.347222,
    width: 24.3056,
    height: 24.3056,
    rx: 4.65278,
    stroke: "#313942",
    strokeWidth: 0.694444
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBack);
export default __webpack_public_path__ + "static/media/headerBack.7c59dfe8cbbb84b71e5eac303d591277.svg";
export { ForwardRef as ReactComponent };